import { Separator } from '../../../../../primitives/separator';
import { ComboboxModel } from '../../../../combobox/combobox-model';

import { ImageUrl } from '../controls/image-url';
import { Spacing } from '../controls/spacing';
import { Appearance } from './appearance';

import type { ContainerEditorContentProps } from './types';

export type { ContainerEditorStyleUpdates } from './types';

export function ContainerEditorContent({
  backgroundColor,
  backgroundImage,
  mediaPicker,
  borderColor,
  borderRadius,
  borderStyle,
  borderWidths,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  margin,
  onStyleChange,
  emailBlocksElement,
  blockOptions,
  selectedBlockId,
  onBlockChange,
}: ContainerEditorContentProps) {
  return (
    <div className="grid gap-4">
      {blockOptions && onBlockChange ? (
        <>
          <ComboboxModel
            classNameCommandList="max-h-[min(15rem,55vh)]"
            model={blockOptions}
            value={selectedBlockId}
            placeholder="Seleccionar bloque"
            onSelect={onBlockChange}
          />
          {emailBlocksElement}
        </>
      ) : null}

      {!blockOptions ? (
        <>
          <Appearance
            backgroundColor={backgroundColor}
            borderColor={borderColor}
            borderRadius={borderRadius}
            borderStyle={borderStyle}
            borderWidths={borderWidths}
            onBorderStyleChange={(borderStyle) => onStyleChange({ borderStyle })}
            onBorderWidthsChange={(borderWidths) => onStyleChange({ borderWidths })}
            onBorderRadiusChange={(borderRadius) => onStyleChange({ borderRadius })}
            onBorderColorChange={(borderColor, settings) =>
              onStyleChange({ borderColor, ...settings })
            }
            onBackgroundColorChange={(backgroundColor) => onStyleChange({ backgroundColor })}
          />

          <ImageUrl
            id="content-container-background-image-url"
            label="URL de imagen de fondo"
            value={backgroundImage}
            mediaPicker={mediaPicker}
            onChange={(value) => onStyleChange({ backgroundImage: value || null })}
          />

          <Separator />

          <Spacing
            margin={margin}
            onChangeMargin={(margin) => onStyleChange({ margin })}
            paddingTop={paddingTop}
            paddingBottom={paddingBottom}
            paddingLeft={paddingLeft}
            paddingRight={paddingRight}
            isPaddingVisible
            onChangePaddingBottom={(bottom) => onStyleChange({ padding: { bottom } })}
            onChangePaddingLeft={(left) => onStyleChange({ padding: { left } })}
            onChangePaddingRight={(right) => onStyleChange({ padding: { right } })}
            onChangePaddingTop={(top) => onStyleChange({ padding: { top } })}
          />
        </>
      ) : null}
    </div>
  );
}
